module.exports = __webpack_public_path__ + "img/icon-type-expired.f8eb4a4b.png";